<template>
  <div class="no-clients">
    <div class="heading">
      Rewarding Dog Training is not currently taking any new clients.
    </div>
    <div class="details">
      If you need support, we highly recommend
      <a href="https://www.trainingwheels.dog/"
        alt="Training Wheels"
        target="_blank"
        rel="noopener noreferrer"
        class="link link-resources"
        :style="{color: this.$themes.primary}" >Training Wheels</a>,
      <a href="https://www.theanimalnature.com/"
        alt="Nature of Animals"
        target="_blank"
        rel="noopener noreferrer"
        class="link link-resources"
        :style="{color: this.$themes.primary}" >The Nature of Animals</a>,
      <a href="https://wisewhiskerstraining.com/"
        alt="Wise Whiskers"
        target="_blank"
        rel="noopener noreferrer"
        class="link link-resources"
        :style="{color: this.$themes.primary}" >Wise Whiskers</a>, and
      <a href="https://www.bolder.dog/"
        alt="Bolder Dog"
        target="_blank"
        rel="noopener noreferrer"
        class="link link-resources"
        :style="{color: this.$themes.primary}" >Bolder Dog</a>
      for your training needs.
    </div>
  </div>
</template>

<script>

export default {
  name: 'no-clients',
}
</script>

<style scoped lang="scss">
.no-clients {
  background-color: #ff000073;
  width: 100%;
  padding: 2rem;
  border-radius: 1rem;
  margin-bottom: 3rem;

  .heading {
    text-align: center;
    font-size: 1.6rem;
    line-height: 1.2;
    font-weight: 500;
  }

  .description {
    text-align: center;
  }
}
</style>
